// Konfiguration des Tag-Feldes — identisch zum Haupt-Frontend
// (`src/lib/visitorFilterConfig.js` dort). Bezeichnung, Beschreibung,
// Einfach-/Mehrfachauswahl und Pflicht werden pro Standort in den
// Visitor-Modul-Settings unter `tag_field` gepflegt.

export const TAG_FIELD_SETTINGS_KEY = "tag_field";

export const DEFAULT_TAG_FIELD = {
  label: "Tags",
  description: "",
  multi: true,
  required: false,
};

/**
 * Tag-Feld-Konfiguration aus den Modul-Settings ableiten. Leeres/fehlendes
 * Label fällt auf „Tags" zurück, `multi` ist nur dann aus, wenn explizit
 * `false` gespeichert wurde. `required` ist Opt-in pro Standort.
 */
export const resolveTagField = (settings) => {
  const cfg = {
    ...DEFAULT_TAG_FIELD,
    ...(settings?.[TAG_FIELD_SETTINGS_KEY] || {}),
  };
  return {
    label: String(cfg.label || "").trim() || DEFAULT_TAG_FIELD.label,
    description: String(cfg.description || "").trim(),
    multi: cfg.multi !== false,
    required: cfg.required === true,
  };
};

/**
 * Fehlt eine Pflicht-Auswahl? Greift nur, wenn es für den Standort überhaupt
 * Tags gibt — sonst wäre die Maske nicht mehr absendbar.
 */
export function isTagSelectionMissing(tagField, options, value) {
  if (!tagField?.required) return false;
  if (!options?.length) return false;
  return !(value || []).length;
}
